import * as types from '../actionTypes/employee'

let defaultState = {
  lobbyistEmployees: [],
  currentEmployee: {},
  employeesForLobbyistByDate: []
}

const employeeReducer = (state = defaultState, action) => {
  if (action.type === types.GET_EMPLOYEE) {
    // if view model not loaded then create empty object so we can bind form in components to that without undefined issues
    if (!action.employee) {
      action.employee = {}
    } else {
      action.employee = {
        ...action.employee,
        // convert dates into date objects before putting into store so they can be treated properly without needing to convert later
        StartDate: action.employee.StartDate ? new Date(action.employee.StartDate) : null,
        EndDate: action.employee.EndDate ? new Date(action.employee.EndDate) : null,
        RestrictionStartDate: action.employee.RestrictionStartDate ? new Date(action.employee.RestrictionStartDate) : null,
        RestrictionEndDate: action.employee.RestrictionEndDate ? new Date(action.employee.RestrictionEndDate) : null
      }
    }
    return {
      ...state,
      currentEmployee: action.employee
    }
  }
  else if (action.type === types.GET_EMPLOYEE_FOR_LOBBYIST) {
    return {
      ...state,
      lobbyistEmployees: action.lobbyistEmployees
    }
  }
   else if (action.type === types.GET_EMPLOYEES_FOR_LOBBYIST_BY_DATE) {
    return {
      ...state,
      employeesForLobbyistByDate: action.employeesForLobbyistByDate
    }
  }
  else if (action.type === types.UPDATE_EMPLOYEE_FOR_LOBBYIST) {
    return {
      ...state,
      lobbyistEmployees: state.lobbyistEmployees.map(lobbyistEmployee => lobbyistEmployee.EmployeeId === action.lobbyistEmployee.EmployeeId ? action.lobbyistEmployee : lobbyistEmployee)
    }
  }
  else if (action.type === types.ADD_EMPLOYEE_TO_LOBBYIST) {
    return {
      ...state,
      lobbyistEmployees: state.lobbyistEmployees.concat({
        ...action.lobbyistEmployee
      })
    }
  }
  else if (action.type === types.REMOVE_EMPLOYEE_FROM_LOBBYIST) {
    return {
      ...state,
      lobbyistEmployees: state.lobbyistEmployees.filter(employee => employee.EmployeeId !== action.employeeId)
    }
  }
  else if (action.type === types.CLEAR_EMPLOYEE) {
    return {
      ...state,
      currentEmployee: {},
      employeeRestrictions: []
    }
  }
  else if (action.type === types.CLEAR_EMPLOYEES_FOR_LOBBYIST) {
    return {
      ...state,
      lobbyistEmployees: []
    }
  }
  else {
    return {
      ...state
    }
  }
}

export default employeeReducer



// WEBPACK FOOTER //
// ./src/reducers/employee.js